<template>
  <li role="presentation">
    <hr
      class="dropdown-divider"
      role="separator"
      aria-orientation="horizontal" />
  </li>
</template>

<script setup lang="ts"></script>

<style scoped></style>
